<div class="grid__row">
	<div class="grid__col--6 grid__col-offset--3">
		<div class="card">
			<div class="card__content">
				<div [innerHtml]="cmsResult.mainContent"></div>
				<rd-login [forgotPasswordUrl]="urls['forgot-password']"></rd-login>
			</div>
		</div>
	</div>
</div>